import { AuditModel } from "./auditModel";

export class Disbursement {
  clientId: any;
  disbusementId: any;
  jobId: string;
  description: any;
  supplierName: any;
  disbursementDate: any;
  isBillable: boolean = true;
  noOfUnits: number;
  unitCost: number;
  unitPrice: any;
  markUp: any;
  total: string;
  disbursementMasterRefId: any;
  jobName: any;
  jobCode: any;
  name: any;
  GST: any;
  taxTypeId: number;
  subTotal:number;
  GSTValue: number;
  isTaxInclude: boolean = false;
}

export class DisbursementMaster {
  disbursementMasterId: any;
  disbursementName: string;
  supplierName: any;
  createdBy: string;
  createdOn: any;
  isArchived: any;
  description: any;
  noOfUnits: number ;
  unitCost: number;
  unitPrice: any;
}

export interface DisbursementPayload {
  disbursementId: string;
  jobId: string;
  disbursementDate: string;
  name: string;
  isBillable: boolean;
  description: string;
  supplierName: string;
  noOfUnits: string;
  unitCost: string;
  unitPrice: string | null;
  markUp: string | null;
  total: string;
  disbursementMasterRefId: number | null;
  notes: string | null;
  created_By: string;
  updated_By: string | null;
  jobName: string;
  subTotal: string;
  gstValue: string;
  gst: string;
  isDeleted: boolean;
}

export interface DisbursementPrivilege {
  canAddOrViewDisbursement: boolean;
  canManageDisbursement: boolean;
}

export enum DisbursementPermissionKeys {
  AddOrViewDisbursement = "IsDisbursementView",
  ManageDisbursement = "IsDisbursementManage",
}

export class Division extends AuditModel {
  public divisionId: any;
  public divisionName: string;
  public description: string;
  public userName: string;
  public billingEntityId: any;
}
